module.exports = __webpack_public_path__ + "components/text-summaries/static/rusty-5da363a53d701c13af5367e78293342f.webp";